export const FETCHING_ACTIVE_VEHICLE_SYSTEMS = '@@toyota/FETCHING_ACTIVE_VEHICLE_SYSTEMS';
export const FETCHED_ACTIVE_VEHICLE_SYSTEMS = '@@toyota/FETCHED_ACTIVE_VEHICLE_SYSTEMS';
export const FETCHED_ACTIVE_VEHICLE_SYSTEMS_FAILED =
  '@@toyota/FETCHED_ACTIVE_VEHICLE_SYSTEMS_FAILED';
export const FETCHING_BULLETIN_SEQUENCE_BY_VEH_SYSTEM =
  '@@toyota/FETCHING_BULLETIN_SEQUENCE_BY_VEH_SYSTEM';
export const FETCHED_BULLETIN_SEQUENCE_BY_VEH_SYSTEM =
  '@@toyota/FETCHED_BULLETIN_SEQUENCE_BY_VEH_SYSTEM';
export const FETCHED_BULLETIN_SEQUENCE_BY_VEH_SYSTEM_FAILED =
  '@@toyota/FETCHED_BULLETIN_SEQUENCE_BY_VEH_SYSTEM_FAILED';

// Query Bulletin
export const FETCHING_BULLETINS = '@@toyota/FETCHING_BULLETINS';
export const FETCHED_BULLETINS = '@@toyota/FETCHED_BULLETINS';
export const FETCHED_BULLETINS_FAILED = '@@toyora/FETCHED_BULLETINS_FAILED';
export const CLEAR_BULLETIN_LIST = '@@toyota/CLEAR_BULLETIN_LIST';

// Bulletin
export const FETCHING_BULLETIN_BY_ID = '@@toyota/FETCHING_BULLETIN_BY_ID';
export const FETCHED_BULLETIN_BY_ID = '@@toyota/FETCHED_BULLETIN_BY_ID';
export const FETCHED_BULLETIN_BY_ID_FAILED = '@@toyota/FETCHED_BULLETIN_BY_ID_FAILED';

export const ADDING_NEW_BULLETIN_SERVICE = '@@toyota/ADDING_NEW_BULLETIN_SERVICE';
export const ADDED_NEW_BULLETIN_SERVICE = '@@toyota/ADDED_NEW_BULLETIN_SERVICE';
export const ADDED_NEW_BULLETIN_FAILED = '@@toyota/ADDED_NEW_BULLETIN_TMC_FAILED';

export const UPDATING_BULLETIN_BY_ID = '@@toyota/UPDATING_BULLETIN_BY_ID';
export const UPDATED_BULLETIN_BY_ID = '@@toyota/UPDATED_BULLETIN_BY_ID';
export const UPDATED_BULLETIN_BY_ID_FAILED = '@@toyota/UPDATED_BULLETIN_BY_ID_FAILED';

export const DOWNLOADING_BULLETIN_RECORD_FILE =
  '@@toyota/DOWNLOADING_BULLETIN_RECORD_FILE';
export const DOWNLOADED_BULLETIN_RECORD_FILE =
  '@@toyota/DOWNLOADED_BULLETIN_RECORD_FILE';
export const DOWNLOADED_BULLETIN_RECORD_FILE_FAILED =
  '@@toyota/DOWNLOADED_BULLETIN_RECORD_FILE_FAILED';

export const FETCHING_BULLETIN_ATTACHMENTS =
  '@@toyota/FETCHING_BULLETIN_ATTACHMENTS';
export const FETCHED_BULLETIN_ATTACHMENTS =
  '@@toyota/FETCHED_BULLETIN_ATTACHMENTS';
export const FETCHED_BULLETIN_ATTACHMENTS_FAILED =
  '@@toyota/FETCHED_BULLETIN_ATTACHMENTS_FAILED';

export const ADDING_BULLETIN_ATTACHMENTS =
  '@@toyota/ADDING_BULLETIN_ATTACHMENTS';
export const ADDED_BULLETIN_ATTACHMENTS =
  '@@toyota/ADDED_BULLETIN_ATTACHMENTS';
export const ADDED_BULLETIN_ATTACHMENTS_FAILED =
  '@@toyota/ADDED_BULLETIN_ATTACHMENTS_FAILED';

export const SENDING_BULLETIN_MAIL = '@@toyota/SENDING_BULLETIN_MAIL';
export const SENDED_BULLETIN_MAIL = '@@toyota/SENDED_BULLETIN_MAIL';
export const SENDED_BULLETIN_MAIL_FAILED = '@@toyota/SENDED_BULLETIN_MAIL_FAILED';

export const SET_BULLETIN_FILES = '@@toyota/SET_BULLETIN_FILES';

export const CLEAR_BULLETIN_INFO = '@@toyota/CLEAR_BULLETIN_INFO';

export const FETCHING_VEHICLE_QUERY = '@@toyota/FETCHING_VEHICLE_QUERY';
export const FETCHED_VEHICLE_QUERY = '@@toyota/FETCHED_VEHICLE_QUERY';
export const FETCHED_VEHICLE_QUERY_FAILED = '@@toyota/FETCHED_VEHICLE_QUERY_FAILED';

export const CLEAR_VEHICLE_QUERY = '@@toyota/CLEAR_VEHICLE_QUERY';
export const CLEAR_BULLETIN_URL_FILE = '@@toyota/CLEAR_BULLETIN_URL_FILE';

export const SAVING_BULLETIN_DOWNLOAD_RECORD = '@@toyota/SAVING_BULLETIN_DOWNLOAD_RECORD';
export const SAVED_BULLETIN_DOWNLOAD_RECORD = '@@toyota/SAVED_BULLETIN_DOWNLOAD_RECORD';
export const SAVED_BULLETIN_DOWNLOAD_RECORD_FAILED =
  '@@toyota/SAVED_BULLETIN_DOWNLOAD_RECORD_FAILED';

export const FETCHING_BULLETIN_DOWNLOAD_RECORD = '@@toyota/FETCHING_BULLETIN_DOWNLOAD_RECORD';
export const FETCHED_BULLETIN_DOWNLOAD_RECORD = '@@toyota/FETCHED_BULLETIN_DOWNLOAD_RECORD';
export const FETCHED_BULLETIN_DOWNLOAD_RECORD_FAILED = '@@toyota/FETCHED_BULLETIN_DOWNLOAD_RECORD_FAILED ';

